import {APIService} from '@custom-types/APIService';
import {APIServiceResponse} from '@custom-types/APIServiceResponse';
import {HttpRequest} from '@services/HttpClient';
import {trackErrorEvents} from '@utils/googleAnalytics/googleAnalyticsEvents';
import {getAPIUrl} from '@utils/service.utils';

export type Projects = Array<{
  projectName: string;
  leadName: string;
  interestArea: string;
}>;
type ResponseData = APIServiceResponse<Projects>;
export type PLParsedData = {
  projects: Projects;
  interests: Record<'label' | 'value', string>[];
};

export function getProjectsList(): APIService<PLParsedData> {
  const route = 'search/feature/get-projects';
  const httpRequest = new HttpRequest<ResponseData>(getAPIUrl('search', route));

  return {
    send: async () => {
      try {
        const response = await httpRequest.send();
        return parseProjects(response.data);
      } catch (err: any) {
        trackErrorEvents({
          type: 'get_projects_fetch_failed',
          errorStack: err,
        });
        throw err;
      }
    },
    abort: httpRequest.abort,
  };
}

function parseProjects(data: Projects) {
  const interestSet = new Set<string>();
  for (const {interestArea} of data) {
    interestSet.add(interestArea);
  }
  const interests = Array.from(interestSet).map((interest) => ({
    value: interest,
    label: interest,
  }));
  return {
    projects: data,
    interests,
  };
}
